import {useCallback} from "react";
import {InputField} from "../../../../components";

function OrderSearchBar({filter, onFilterChange})
{
    const handleSearchChange = useCallback((e) => {
        onFilterChange?.({keyword: e.target.value});
    }, [onFilterChange]);

    return (
        <div className="search-bar pt-0 pb-2">
            <div className="container">
                <form className="form p-0" autoComplete="off">
                    <InputField name="keyword" value={filter?.keyword} placeholder="Mã đơn hàng" onChange={handleSearchChange} />
                </form>
            </div>
        </div>
    );
}

export default OrderSearchBar;
